























































import { Component, Vue } from "vue-property-decorator";
import { Button, Field, Icon } from "vant";
import { getBrowser } from "@/utils/browser";
import { goBack } from "@/utils/hybirdMethods";
import customField from "@/components/customField/index.vue";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
import navButtons from "@/views/app-pages/components/navButtons.vue";

const browser = getBrowser();

@Component({
  components: {
    navButtons,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field,
    [customField.name]: customField,
    passwordErrorPrompt
  }
})
export default class Login extends Vue {
  form = {
    old_password: "",
    new_password: "",
    repeat_password: ""
  };

  pwdErrPromptOption = {
    show: false,
    errCode: -1,
    errHtml: ""
  };

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get isDisabledSubmit() {
    return Object.keys(this.form).some(key => {
      return !this.form[key];
    });
  }

  handleSubmit() {
    // if (!verifyTradePassword(this.form.new_password)) {
    //   return this.$toast.fail(
    //     this.$t(
    //       "security_center.login_password_modify.new_password_verify_fail_text"
    //     )
    //   );
    // }
    if (!this.regexValidatePassword(this.form.new_password)) {
      return this.$toast.fail(
        this.$t(
          "security_center.login_password_modify.new_password_verify_fail_text"
        )
      );
    }
    if (this.form.repeat_password !== this.form.new_password) {
      return this.$toast.fail(
        this.$t(
          "security_center.login_password_modify.new_password_repeat_fail_text"
        )
      );
    }
    (this as any).$apis
      .modifyLoginPassword(this.form)
      .then((res) => {
        // TODO: 修改密码-登录错误 Code 100173
        // TODO: 修改密码-登录错误，冻结 Code 100174
        if (res.code) {
          if (res.code === 100174 || res.code === 100173) {
            this.pwdErrPromptOption.errCode = res.code;
            this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
            this.pwdErrPromptOption.show = true;
            (this as any).$refs["password-error-prompt-el"].show = true;
            return;
          } else {
            this.$toast(res.msg);
          }
        }else{
          if (browser.isApp) {
            goBack();
            return;
          }
          setTimeout(() => {
            this.form = {
              old_password: "",
              new_password: "",
              repeat_password: ""
            };
          }, 200);

          this.$toast(this.$t("common.opera_success"));
        }
        // this.$router.push("/electronic-sign");



      })
      .catch(e => {
        
      });
  }

  regexValidatePassword(password) {
    const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;

    return passwordRegex.test(password);
  }

  passwordErrorPromptConfirm(errCode) {
    if (errCode === 100173) {
      // (this as any).form.old_password = '';
      // (this as any).form.new_password = '';
      // (this as any).form.repeat_password = '';
      (this as any).$refs["custom-field-old-password"].setInputFocus();
    }
  }

  toForgetPassword() {
    this.$router.push("/login-password-forget");
  }
}
